export default {
  name: 'processing',
  path: 'processing-time',
  component: () => import(/* webpackChunkName: "Processing" */ '@/views/report/processing/index'),
};
